import React from 'react';
import { Button, Form, Segment, Input } from 'semantic-ui-react';
import axios from 'axios';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class LeaseholderFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnitId: null,
            entityType: null,

            physicalEntityName: null,
            physicalEntityLastName: null,
            physicalEntityJMBG: null,

            legalEntityName: null,
            legalEntityIdNumber: null,

            organizationalUnitEntity: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
    }

    onFilterData() {
        const leaseholderFilterData = {
            organizationalUnit: this.state.organizationalUnitId,

            entityType: this.state.entityType,
            physicalEntity: null,
            legalEntity: null,
        };

        this.props.onFilterData(leaseholderFilterData);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <Segment raised>
                <Form>
                    {this.props.organizationalUnitPrivilege &&
                        <Form.Group widths="3">
                            <Form.Dropdown clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Group>
                    }

                    <Form.Group widths="3">
                        <Form.Dropdown clearable
                            label="Tip zakupca"
                            placeholder="Izaberite tip zakupca"
                            value={this.state.entityType}
                            onChange={this.handleInputChange}
                            name="entityType"
                            options={this.props.entityTypes}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>

                    {(this.state.entityType === 5) &&
                        <Form.Group widths="equal">
                            <Form.Field
                                label="Ime"
                                control={Input}
                                name="physicalEntityName"
                                value={this.state.physicalEntityName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite ime"
                            />

                            <Form.Field
                                label="Prezime"
                                control={Input}
                                name="physicalEntityLastName"
                                value={this.state.physicalEntityLastName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite prezime"
                            />

                            <Form.Field
                                label="JMBG"
                                control={Input}
                                name="physicalEntityJMBG"
                                value={this.state.physicalEntityJMBG}
                                onChange={this.handleInputChange}
                                placeholder="Unesite JMBG"
                            />

                            <Form.Field
                                label="Napomena"
                                control={Input}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                                placeholder="Unesite napomenu"
                            />
                        </Form.Group>
                    }

                    {(this.state.entityType === 5) &&
                        <Form.Group widths="equal">
                            <Form.Field
                                label="Naziv"
                                control={Input}
                                name="legalEntityName"
                                value={this.state.legalEntityName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite naziv"
                            />

                            <Form.Field
                                label="ID"
                                control={Input}
                                name="legalEntityIdNumber"
                                value={this.state.legalEntityIdNumber}
                                onChange={this.handleInputChange}
                                placeholder="Unesite naziv"
                            />

                            <Form.Field
                                label="Napomena"
                                control={Input}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                                placeholder="Unesite napomenu"
                            />
                            <Form.Field></Form.Field>
                        </Form.Group>
                    }

                    {(this.state.entityType === 5) &&
                        <Form.Group widths="equal">
                            <Form.Dropdown clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.organizationalUnitEntity}
                                onChange={this.handleInputChange}
                                name="organizationalUnitEntity"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                            />
                            <Form.Field
                                label="Napomena"
                                control={Input}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                                placeholder="Unesite napomenu"
                            />
                            <Form.Field></Form.Field>
                            <Form.Field></Form.Field>
                        </Form.Group>
                    }

                    <Button
                        color="blue"
                        onClick={() => this.onFilterData()}
                    >
                        Filtriraj
                    </Button>
                    <Button
                        basic
                        color="blue"
                        onClick={this.props.cancelFilter}
                    >
                        Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderFilter.js